import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=03d84bb6&scoped=true&"
import script from "./AdminCategories.vue?vue&type=script&lang=js&"
export * from "./AdminCategories.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategories.vue?vue&type=style&index=0&id=03d84bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d84bb6",
  null
  
)

export default component.exports